import { render, staticRenderFns } from "./loginJournal.vue?vue&type=template&id=4b225fd6&scoped=true"
import script from "./loginJournal.vue?vue&type=script&lang=js"
export * from "./loginJournal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b225fd6",
  null
  
)

export default component.exports